export default {
    install(Vue, options) {
 
        Vue.prototype.$trackPageView = function (title) {
            if (this.$matomo) {
                let path = window.location.href;
                this.$matomo.setCustomUrl(path);
                this.$matomo.trackPageView(title);
            }
        }

    }
 }